export default "__VITE_ASSET__BAP3HlFy__"